import React from 'react';

import Tooltip, { TooltipText, VARIANTS } from 'components/shared/Tooltip';

type Props = {
  tooltipId: string;
};

function SaveInfoTooltip({ tooltipId }: Props) {
  return (
    <Tooltip variant={VARIANTS.DARK} id={tooltipId} data-tooltip-position-strategy="absolute">
      <TooltipText>
        In the future, selecting the same Content Page will auto-fill
        <br />
        all previously entered information, including the event icon.
      </TooltipText>
    </Tooltip>
  );
}

export default SaveInfoTooltip;
